import { render } from "./TouchpointContentCard.vue?vue&type=template&id=58071a44"
import script from "./TouchpointContentCard.vue?vue&type=script&lang=js"
export * from "./TouchpointContentCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/playbooks/TouchpointContentCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58071a44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58071a44', __exports__)) {
    api.reload('58071a44', __exports__)
  }
  
  module.hot.accept("./TouchpointContentCard.vue?vue&type=template&id=58071a44", () => {
    api.rerender('58071a44', render)
  })

}


export default __exports__